/**
* For this scoped component we should use the namespace prefix of "dc-button"
*/
:host {
  display: inline;
}

:host * {
  font-family: var(--dc-font-family);
}

/* Common CSS */
.dc-button-btn {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-decoration: none;
}

.dc-button-text:empty {
  display: none;
}

.dc-button-btn:hover:enabled {
  cursor: pointer;
  background-color: var(--dc-background-accent-color);
}

.dc-button-image-right {
  flex-direction: row-reverse;
}

.dc-button-size-large.dc-button-image-left .dc-button-image {
  padding-right: 12px;
}

.dc-button-size-large.dc-button-image-right .dc-button-image {
  padding-left: 12px;
}

.dc-button-size-small.dc-button-image-left .dc-button-image {
  padding-right: 8px;
}

.dc-button-size-small.dc-button-image-right .dc-button-image {
  padding-left: 8px;
}

.dc-button-size-small {
  height: 34px;
  line-height: 18px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  /*min-width: 110px;*/
}

.dc-button-size-small .dc-button-image {
  height: 16px;
  width: 16px;
}

.dc-button-size-large {
  height: 48px;
  line-height: 24px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 18px;
  /* min-width: 150px;*/
}

.dc-button-size-large .dc-button-image {
  height: 18px;
  width: 18px;
}

.dc-button-loading .dc-button-text {
  visibility: hidden;
}

.dc-button-loading .dc-button-image {
  visibility: hidden;
}

.dc-button-spinner {
  animation: dc-button-rotate 2s linear infinite;
  display: inline-block;
  height: 36px;
  position: absolute;
}

.dc-button-size-small .dc-button-spinner {
  height: 16px;
}

.dc-button-spinner circle {
  stroke-linecap: round;
  animation: dc-button-dash 1.5s ease-in-out infinite;
}

@keyframes dc-button-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dc-button-dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

/* Primary */
.dc-button-primary {
  color: var(--dc-background-colour);
  background-color: var(--dc-primary-colour);
  border: none;
  fill: var(--dc-background-colour);
  stroke: var(--dc-background-colour);
}

.dc-button-primary:focus {
  outline: 2px solid var(--dc-primary-colour);
  outline-offset: 1px;
}

.dc-button-primary:hover:enabled,
.dc-button-primary:active:enabled {
  background-color: var(--dc-primary-accent-colour);
  outline: none;
}

.dc-button-primary:disabled {
  color: var(--dc-primary-disabled-text-colour);
  background-color: var(--dc-primary-disabled-colour);
  fill: var(--dc-primary-disabled-text-colour);
  stroke: var(--dc-primary-disabled-text-colour);
  cursor: not-allowed;
}

/* Secondary */
.dc-button-secondary {
  color: var(--dc-primary-colour);
  background-color: var(--dc-background-colour);
  border-color: var(--dc-primary-colour);
  border-width: 2px;
  border-style: solid;
  fill: var(--dc-primary-colour);
  stroke: var(--dc-primary-colour);
}

.dc-button-secondary:focus {
  outline: 3px solid var(--dc-primary-colour);
  border-color: var(--dc-primary-colour);
  color: var(--dc-primary-colour);
  outline-offset: 1px;
}

.dc-button-secondary:hover:enabled,
.dc-button-secondary:active:enabled {
  color: var(--dc-primary-accent-colour);
  border-color: var(--dc-primary-accent-colour);
  background-color: var(--dc-background-accent-color);
  outline: none;
  fill: var(--dc-primary-accent-colour);
  stroke: var(--dc-primary-accent-colour);
}

.dc-button-secondary:disabled {
  color: var(--dc-primary-disabled-colour);
  border-color: var(--dc-primary-disabled-colour);
  fill: var(--dc-primary-disabled-colour);
  stroke: var(--dc-primary-disabled-colour);
  cursor: not-allowed;
}

/* Tertiary */
.dc-button-tertiary {
  color: var(--dc-primary-colour);
  background-color: var(--dc-background-colour);
  border-width: 2px;
  border: none;
  fill: var(--dc-primary-colour);
  stroke: var(--dc-primary-colour); 
}

.dc-button-tertiary:focus {
  outline: 2px solid var(--dc-primary-colour);
  outline-offset: 1px;
  color: var(--dc-primary-colour);
}

.dc-button-tertiary:hover:enabled,
.dc-button-tertiary:active:enabled {
  background-color: var(--dc-background-accent-color);
  color: var(--dc-primary-accent-colour);
  outline: none;
  fill: var(--dc-primary-accent-colour);
  stroke: var(--dc-primary-accent-colour);
}

.dc-button-tertiary:disabled {
  color: var(--dc-primary-disabled-colour);
  stroke: var(--dc-primary-disabled-colour);
  fill: var(--dc-primary-disabled-colour);
  cursor: not-allowed;
}

